<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    松岗站<br>
站点介绍<br>
松岗站为6、11号线的换乘站，位于宝安大道与沙江路十字路口，沿沙江路呈东西向布置，为地下三层侧式车站。6号线站台位于地下三层，与11号线公用站厅。车站周边为居住、工业、商业用地，主要有沙浦村、松岗派出所、朗下村、御景城、沙浦围花园。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:20	23:00	6号线	3分24秒	6分20秒<br>
松岗	--	--	6号线	3分24秒	6分20秒<br>
岗厦北	06:07	23:38	11号线	4分钟	6分32秒<br>
碧头	06:44	00:28	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:20	23:00	6号线	4分45秒	6分钟<br>
松岗	--	--	6号线	4分45秒	6分钟<br>
岗厦北	06:07	23:38	11号线	4分34秒	6分钟<br>
碧头	06:44	00:28	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:20	00:00	6号线	4分45秒	6分钟<br>
松岗	--	--	6号线	4分45秒	6分钟<br>
岗厦北	06:07	23:38	11号线	4分37秒	6分钟<br>
碧头	06:44	00:28	11号线	4分37秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
沙浦围花园<br><br>
C出入口:<br>
沙浦围公园、朗下广场、朗碧路、松兴路、沙江路、沙浦二村御景城、松河北路、中海˙西安华府、沙浦围工业大道、松明大道、辉景商务大厦、河滨南路、京港澳高速、深圳复亚医院、松岗天虹、永辉超市、松乔酒店、宝安大道西侧、沙江路（南）、佳裕大厦、松岗桥底、松岗人民医院<br><br>
D出入口:<br>
溪头工业四路、溪头工业三路、溪头八达小区、宏利大厦、景祥楼、松瑞路、景湖家园、松河北路、新华楼、福源大厦、河滨南路、华利凯大厦、永淳商务大厦、恒伟大厦、盛世楼、松岗派出所、沿河路、松瑞天虹<br><br>
E出入口:<br>
松岗派出所<br><br>
F出入口:<br><br>
维也纳酒店<br><br>
G出入口:<br>
平安居、沙浦社区健康服务中心、沙浦围花园、沙浦社区公园、深圳市沙浦门球场、沙浦一村、松岗街道沙浦社区工作站、聚豪酒店、宝安大道东侧、塘下涌、长安<br><br>
公交换乘信息<br><br>
G出入口:<br>
公交站名： 松岗地铁站<br>
M291、M490、M513、M542、高峰专线142<br><br>
C出入口:<br>
公交站名： 松岗地铁站<br>
B900、B933、B941、M498、M513、MM541、M255、M291、M490、M542、高峰专线142<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiyihaoxian",
          title: "11号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>